var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftSolidRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 25,
    viewBox: "0 0 12 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1058_29883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3018 3.11475L1.55176 13.1179L10.3018 23.1147",
    stroke: "#FE4B4E",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1058_29883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 12,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftSolidRed);
export default __webpack_public_path__ + "static/media/arrow_left_solid_red.3d80be00191f74acaa1f2efb8513fd40.svg";
export { ForwardRef as ReactComponent };